import useText from '../common/hooks/useText'

const useShortDatesNames = () => {
    const text = useText()

    const dayOfWeek = (dayNumber: number) => {
        switch (dayNumber) {
            case 1:
                return text('lblMonday')
            case 2:
                return text('lblTuesday')
            case 3:
                return text('lblWednesday')
            case 4:
                return text('lblThursday')
            case 5:
                return text('lblFriday')
            case 6:
                return text('lblSaturday')
            case 7:
                return text('lblSunday')
            default:
                return text('lblMonday')
        }
    }

    return (days: string): string[] =>
        days.split('').map((item, index) => {
            if (item === '-') return item
            return dayOfWeek(index + 1).charAt(0)
        })
}
export default useShortDatesNames
